import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import AwardsBanner from "./awards-banner"; 
import AwardsLists from './awards-list';

function AwardsPage() {
  
    return (
      <Fragment> 
      <Header />  
      <AwardsBanner />   
      <AwardsLists />
      <Footer /> 

</Fragment> 
  );
}

export default AwardsPage;